// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"d466eb89","569":"21d31df4","818":"f1929373","837":"e7459ea3","852":"56c5397f"}[chunkId] + ".chunk.css";
};